// Configuración de partículas para tsParticles
// Puedes modificar estos valores para personalizar el efecto

export const particlesConfig = {
  background: {
    color: {
      value: "transparent",
    },
  },
  fpsLimit: 120,
  interactivity: {
    events: {
      onClick: {
        enable: true,
        mode: "repulse",
      },
      onHover: {
        enable: true,
        mode: "repulse",
      },
      resize: {
        enable: true,
        delay: 0.5
      },
    },
    modes: {
      push: {
        quantity: 2,
      },
      repulse: {
        distance: 180,
        duration: 0.45,
      },
    },
  },
  particles: {
    color: {
      value: "#ffffff", // Color de las partículas
    },
    links: {
      color: "#ffffff", // Color de las líneas de conexión
      distance: 150, // Distancia máxima para conectar partículas
      enable: true, // Habilitar líneas de conexión
      opacity: 0.3, // Opacidad de las líneas
      width: 1, // Grosor de las líneas
    },
    move: {
      direction: "none",
      enable: true,
      outModes: {
        default: "bounce",
      },
      random: false,
      speed: 1.2, // Velocidad de movimiento reducida
      straight: false,
    },
    number: {
      density: {
        enable: true,
        width: 1920,
        height: 1080
      },
      value: 70, // Cantidad base de partículas
      limit: 90, // Máximo permitido incluso si se agregan dinámicamente
    },
    opacity: {
      value: 0.5, // Opacidad de las partículas
    },
    shape: {
      type: "circle", // Forma de las partículas (circle, edge, triangle, polygon, star, etc.)
    },
    size: {
      value: { min: 1, max: 5 }, // Tamaño de las partículas
    },
  },
  detectRetina: true,
};

// Configuración alternativa con efecto de nieve
export const snowConfig = {
  background: {
    color: {
      value: "transparent",
    },
  },
  fpsLimit: 120,
  particles: {
    color: {
      value: "#ffffff",
    },
    move: {
      direction: "bottom",
      enable: true,
      outModes: {
        default: "out",
      },
      random: false,
      speed: 2,
      straight: false,
    },
    number: {
      density: {
        enable: true,
      },
      value: 100,
    },
    opacity: {
      value: 0.8,
    },
    shape: {
      type: "circle",
    },
    size: {
      value: { min: 1, max: 3 },
    },
  },
  detectRetina: true,
};

// Configuración con efecto de estrellas
export const starsConfig = {
  background: {
    color: {
      value: "transparent",
    },
  },
  fpsLimit: 120,
  particles: {
    color: {
      value: "#ffffff",
    },
    move: {
      enable: false,
    },
    number: {
      density: {
        enable: true,
      },
      value: 150,
    },
    opacity: {
      value: {
        min: 0.1,
        max: 1,
      },
      animation: {
        enable: true,
        speed: 1,
        sync: false,
      },
    },
    shape: {
      type: "circle",
    },
    size: {
      value: { min: 1, max: 3 },
    },
  },
  detectRetina: true,
};

